module.exports = __webpack_public_path__ + "static/media/KaTeX_Caligraphic-Regular.00029fb4.woff";